import pageHoc from 'hocs/pageHoc';
import Vouches, { pageTitle } from './Vouches';

export default pageHoc({ title: pageTitle })(Vouches);
